import * as RadixDialog from '@radix-ui/react-dialog'
import { noop } from '@reatom/framework'
import { motion, usePresence } from 'motion/react'
import { useEffect } from 'react'
import styled from 'styled-components'

import { useBackButton } from '@blade/ui-kit'
import { useRootElement } from '@root/shared/ui-kit'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type ModalScreenProps = {} & ClassNameProps & ChildrenProps

export const ModalScreen: React.FC<ModalScreenProps> = ({
  className,
  children,
}) => {
  const presence = usePresence()
  const dialogsContainer = useRootElement()

  const [isPresent, safeToRemove] = presence
  // Blocking back button stack
  useBackButton(noop)

  useEffect(() => {
    if (!isPresent) {
      setTimeout(() => {
        safeToRemove()
      }, 400)
    }
  }, [isPresent, safeToRemove])

  return (
    <RadixDialog.Root open modal>
      <RadixDialog.Portal container={dialogsContainer}>
        <RadixDialog.Overlay />
        <RadixDialog.Content autoFocus={false}>
          <Root
            initial={{ y: '100%' }}
            animate={{
              y: isPresent ? 0 : '100%',
            }}
            transition={{ duration: 0.4, ease: 'easeInOut' }}
            className={className}
            // Prevent auto focus issued buy Dialog's focus trap
            tabIndex={0}
          >
            {children}
          </Root>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  )
}

const Root = styled(motion.div)`
  padding-block: var(--safe-top) var(--safe-area-inset-bottom);
  position: fixed;
  inset: 0;
  z-index: 10;
`
